export const INITIAL_STATE = {
  user: null,
  session: null,

  loginLoading: false,
  loginSuccess: null,
  loginFailure: null,

  loginAuthLoading: false,
  loginAuthSuccess: null,
  loginAuthFailure: null,

  loginHerokuLoading: false,
  loginHerokuSuccess: null,
  loginHerokuFailure: null,

  loginTokenExchangeLoading: false,
  loginTokenExchangeSuccess: null,
  loginTokenExchangeFailure: null,

  registerLoading: false,
  registerSuccess: null,
  registerFailure: null,

  saveSignUp: null,
  saveCreateProfile: null,

  logoutLoading: false,
  logoutSuccess: null,
  logoutFailure: null,

  getSessionLoading: false,
  getSessionSuccess: null,
  getSessionFailure: null,

  getSessionUserLoading: false,
  getSessionUserSuccess: null,
  getSessionUserFailure: null,

  changePasswordLoading: false,
  changePasswordSuccess: null,
  changePasswordFailure: null,

  changeRecoveryQuestionLoading: false,
  changeRecoveryQuestionSuccess: null,
  changeRecoveryQuestionFailure: null,

  forgotPasswordLoading: false,
  forgotPasswordSuccess: null,
  forgotPasswordFailure: null,

  sessionRefreshLoading: false,
  sessionRefreshSuccess: null,
  sessionRefreshFailure: null
}
